import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useDispatch, useSelector } from "react-redux";
import { UpdatePassword } from "store/slice/usersSlice";
import Alert from "components/Alert/Alert";
import { useTranslation } from "react-i18next";
import { userActions } from "store/slice/usersSlice";
import { useLocation } from "react-router-dom";

function ChangePassword() {
  const dispatch = useDispatch();
  const { search } = useLocation();

  const usersStore = useSelector((store) => store.user);
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get('token');

  const { t } = useTranslation();
  console.log("usersStore.updatePasswordSuccess ", usersStore.updatePasswordSuccess)
  useEffect(() => {
    return () => {
      dispatch(userActions.reset());
    };
  }, [dispatch]);

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm password is required"),
  });

  const handleSubmit = (values, { resetForm, setSubmitting }) => {
  
    dispatch(UpdatePassword({password: values.password, token}))
      .unwrap()
      .then((result) => {
        resetForm();
      })
      .catch((error) => {
        setSubmitting(false);
      });
  };

  return (
    <BasicLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Update Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Enter and confirm your new password
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {usersStore.updatePasswordError?.status ? (
            <Alert message={t(usersStore.updatePasswordError?.message)} />
          ) : (
            ""
          )}
          {usersStore.updatePasswordSuccess?.status ? (
            <Alert
              message={t(usersStore.updatePasswordSuccess?.message)}
              isSuccess={true}
            />
          ) : (
            ""
          )}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form>
                <MDBox mb={4}>
                  <Field
                    name="password"
                    as={MDInput}
                    type="password"
                    label="Password"
                    variant="standard"
                    fullWidth
                    error={touched.password && Boolean(errors.password)}
                  />
                  <MDTypography
                    variant="caption"
                    color="error"
                    style={{ marginTop: "4px", display: "block" }}
                  >
                    <ErrorMessage name="password" />
                  </MDTypography>
                </MDBox>
                <MDBox mb={4}>
                  <Field
                    name="confirmPassword"
                    as={MDInput}
                    type="password"
                    label="Confirm Password"
                    variant="standard"
                    fullWidth
                    error={
                      touched.confirmPassword && Boolean(errors.confirmPassword)
                    }
                  />
                  <MDTypography
                    variant="caption"
                    color="error"
                    style={{ marginTop: "4px", display: "block" }}
                  >
                    <ErrorMessage name="confirmPassword" />
                  </MDTypography>
                </MDBox>
                <MDBox mt={6} mb={1}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    fullWidth
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Update Password
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              Sign in?{" "}
              <MDTypography
                component={Link}
                to="/auth/login"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                Sign in
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ChangePassword;
